<template>
    <ul v-if="menu.items" class="menu-item">
        <a
            class="footer-menu hasChild"
            :class="{ down: down }"
            :style="useMenuStyle"
            @click.prevent="menuClick"
            @mousedown.prevent
            rel="noopener noreferrer"
            role="button"
            :aria-haspopup="true"
            :aria-expanded="down"
            tabindex="0"
        >
            <span
                class="menu-label uppercase"
                :title="getMenuName(menu).toUpperCase()"
            >
                {{ getMenuName(menu) }}
            </span>
            <i v-if="smallDown" class="iconfont icon-fashion-down"></i>
            <i v-else class="iconfont icon-arrow-down"></i>
        </a>
        <ol class="footer-submenu" v-show="down" :style="useSubMenuStyle">
            <li
                v-for="(subMenu, index) in menu.items"
                :key="subMenu.name + '-' + index"
                class="sub-menu"
            >
                <a
                    class="submenu-text uppercase"
                    :href="`${
                        subMenu.items && subMenu.items.length
                            ? subMenu.items[0].link
                            : subMenu.link
                    }`"
                    :target="menu.target"
                    rel="noopener noreferrer"
                    :title="getMenuName(subMenu).toUpperCase()"
                >{{ getMenuName(subMenu) }}</a>
            </li>
        </ol>
    </ul>
    <ul v-else class="menu-item">
        <a
            class="footer-menu"
            :href="menu.link"
            :target="menu.target"
            rel="noopener noreferrer"
            role="button"
            :style="useMenuStyle"
        >
            <span
                class="menu-label uppercase"
                :title="getMenuName(menu).toUpperCase()"
            >
                {{ getMenuName(menu) }}
            </span>
        </a>
    </ul>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';

import { defaultLngCode } from '@/globalization/constant.js';
export default {
    // emits: ['updateExpandKey', 'calcFixed'],
    emits: ['updateExpandKey'],
    props: {
        selfKey: {
            type: String,
            default: ''
        },
        expandKey: {
            type: String,
            default: ''
        },
        menu: {
            type: Object,
            default: () => ({})
        },
        useMenuStyle: {
            type: Object,
            default: null
        },
        useSubMenuStyle: {
            type: Object,
            default: null
        },
        smallDown: {
            type: Boolean,
            default: false
        }
    },
    // data: function() {
    //     return {
    //         active: false
    //     };
    // },
    // mounted() {
    //     this.getActive();
    // },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page,
            'currentLanguage': store => store.currentLanguage
        }),
        
        down() {
            return this.selfKey === this.expandKey;
        },
        links() {
            const links = [];
            if (this.menu.items && this.menu.items.length) {
                const menutItems = this.menu.items;
                for (let i = 0, len = menutItems.length; i < len; i++) {
                    const item = menutItems[i];
                    if (item.items && item.items.length) {
                        const itemItems = item.items;
                        for (
                            let j = 0, jlen = itemItems.length;
                            j < jlen;
                            j++
                        ) {
                            links.push(itemItems[j].link);
                        }
                    } else if (item.link) {
                        links.push(item.link);
                    }
                }
            } else if (this.menu.link) {
                links.push(this.menu.link);
            }
            return links;
        }
    },
    methods: {
        getMenuName(menu) {
            return (
                menu.sysLanguage?.[this.currentLanguage]?.name ||
                menu.sysLanguage?.[defaultLngCode]?.name ||
                menu.name
            );
        },
        menuClick() {
            this.$emit('updateExpandKey', this.down ? '' : this.selfKey);
            // this.$emit('calcFixed');
        },
        // getActive() {
        //     let path = this.pageLocation.pathname;
        //     if (path === '/about/buyer' || path === '/about/seller') {
        //         path = '/about';
        //     }
        //     for (let i = 0, len = this.links.length; i < len; i++) {
        //         let link = this.links[i];
        //         link = link.split('?')[0];
        //         if (placeReg.test(link)) {
        //             let reg = link
        //                 .replace(/\//g, '\\/')
        //                 .replace(/\:\w+/g, '[^/]+');
        //             if (
        //                 new RegExp(reg).test(path) &&
        //                 this.page.currentLink !== link
        //             ) {
        //                 this.active = true;
        //                 break;
        //             }
        //         } else {
        //             if (link == path && this.page.currentLink !== link) {
        //                 this.active = true;
        //                 break;
        //             }
        //         }
        //     }
        //     return false;
        // }
    }
};
</script>

<style lang="scss">
.md-footer .menu-item {
    padding-left: 10px;
    .footer-menu {
        color: var(--origin-menu-color,#FFFFFF);
        padding-right: 10px;
        &:hover {
            color: var(--hover-menu-color,#FFFFFF) !important;
            .iconfont {
                color: var(--hover-menu-color,#FFFFFF) !important;
            }
            .menu-label {
                color: var(--hover-menu-color,#FFFFFF) !important;
            }
        }
        .icon-fashion-down {
            font-size: 12px;
            transform: rotate(180deg) scale(0.4);
        }
        &.down {
            .icon-fashion-down {
                transform: scale(0.4);
            }
        }
        .iconfont {
            color: var(--origin-menu-color,#FFFFFF);
        }
        .menu-label {
            color: var(--origin-menu-color,#FFFFFF);
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &.hasChild {
            display: flex;
            align-items: center;
        }
    }
    .footer-submenu .sub-menu {
        color: var(--origin-sub-color,#FFFFFF);
        &:hover {
            color: var(--hover-sub-color,#FFFFFF) !important;
        }
        .submenu-text {
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .uppercase {
        text-transform: uppercase;
    }
}
</style>
